import { render } from "./AdminNavbar.vue?vue&type=template&id=156c35d0"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-simple-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__